<template>
    <div class="runtime-custom-form">
        <login-in :loginType="loginType"
            :isLoginFlag="isLoginFlag"
            :activityTypeFlag="activityTypeFlag"
            :activityUrl="activityUrl">
        </login-in>
        <div :class="{ noLogin: isNoLogin }">
            <div v-if="showHistory"
                class="history"
                @click="queryHistoryData">查看历史</div>
            <div ref="dynamicAttrContent"
                class="dynamic-attr-content"
                :style="{width: $pScreen.mainW}">
                <div class="custom-form-title"></div>
                <div class="custom-form-top-img">
                    <img :style="{width: $pScreen.mainW,height: '56vw'}"
                        :src="activityPictureUrl"
                        alt>
                </div>
                <div v-if="showCoupon"
                    class="couponTips"
                    :style="{width: '100%',paddingLeft: '15px'}">
                    提交表单后您将有机会获得以下奖励：{{couponReward}}
                </div>
                <div v-for="(item,index) in questionList"
                    :key="index"
                    class="question-content">
                    <div class="dynamic-property-form">
                        <component :attrObj="item"
                            :is="item.questionType"
                            :positionInfo="positionInfo"
                            :channelStore="item.activityItemChannel"></component>
                    </div>
                </div>
            </div>

            <div class="btn-tool align-center"
                style="width: 100%">
                <!-- 当表单是微信登陆且没有登录时提交按钮也置灰，表单是微信登陆且已登陆或无需登陆时可以正常点击 -->
                <Button :class="submitButtonIsDisabled ? 'disabled btn-submit' : 'btn-submit'"
                    :style="{width: '90%',height: '40px',fontSize:$pScreen.titleS, background: previewFlag ? '#ccc' : ''}"
                    :disabled="submitButtonIsDisabled"
                    v-on:click.stop="submit">{{ submitDocument }}</Button>
            </div>
            <selectHistoryFormDialog ref="selectHistoryFormDialog"
                @goDetail="goDetail"></selectHistoryFormDialog>
            <formCouponModal ref="formCouponModal"
                :awardObj="awardObj"
                @confirmModal="confirmModal"></formCouponModal>

            <!-- 提交已截止弹窗 -->
            <van-dialog v-model="isCutoff"
                className="cutoffDialog"
                :showConfirmButton="false">
                <div class="cutoff">
                    <img src="static/runtime/images/magic/finished.png">
                    <div class="cutoffText">提交无效，该活动已截止提交~</div>
                    <div class="cutoffButton"
                        @click="isCutoff=false">关闭</div>
                </div>
            </van-dialog>

            <!-- 是否继续提交 -->
            <van-dialog v-model="isContinue"
                className="continue"
                :showConfirmButton="false">
                <img src="static/runtime/images/magic/continueFlag.png" />
                <div class="continueButton1"
                    @click="handleBacks"></div>
                <div class="continueButton2"
                    @click="handleContinue"></div>
            </van-dialog>
            <!-- 活动未开始、已暂停、已结束弹窗 -->
            <activity-status-dialog ref="activityStatusDialogRef"
                :activityStatus="activityStatus"
                :time="time"
                :activityStartDate="activityStartTime"
                :activityEndDate="activityEndTime"
                :showTime="showTime"
                :timeIntervalState="timeIntervalState"
                @timeDownFinished="timeDownFinished"></activity-status-dialog>
            <IncorrectClient :isDisplay="!isCorrectClient"
                :loginType="originLoginType"></IncorrectClient>
        </div>
    </div>
</template>

<script>
import { directive as clickOutside } from '@/utils/component/v-click-outside-x';
import single_choice from './dynamicAttr/radio';
import multiple_choice from './dynamicAttr/checkbox';
import single_text from './dynamicAttr/input';
import multiple_text from './dynamicAttr/textarea';
import attachment from './dynamicAttr/fileUpload';
import form_time from './dynamicAttr/time';
import evaluation from './dynamicAttr/score';
import submittedForm from './submittedForm';
import ActivityStatusDialog from '../customForm/activity-status-dialog.vue';
import selectHistoryFormDialog from '../customForm/select-history-form-dialog.vue';
import formCouponModal from './dynamicAttr/modal/form-coupon-modal';
import address_text from './dynamicAttr/address';
import name_text from './dynamicAttr/nameText';
import phone_text from './dynamicAttr/phoneText';
import channel from './dynamicAttr/channel.vue';
import wx from 'weixin-js-sdk';
import { Dialog, Toast, Icon, List } from 'vant';
import comUtils from '../../../utils/comUtils.js';
import loginIn from './dynamicAttr/modal/login-in.vue';
import IncorrectClient from './dynamicAttr/incorrect-client.vue';
import { checkClient, getPosition } from './common-methods/utils';
import { ActivityStatus, LoginType, TimeIntervalState } from '../../../commons/commonVariables';
import { AMapGetLocation } from './TMap.js';
export default {
  components: {
    single_choice,
    multiple_choice,
    single_text,
    multiple_text,
    attachment,
    form_time,
    evaluation,
    submittedForm,
    formCouponModal,
    address_text,
    name_text,
    phone_text,
    channel,
    [Dialog.Component.name]: Dialog.Component,
    [Icon.name]: Icon,
    loginIn,
    IncorrectClient,
    ActivityStatusDialog,
    selectHistoryFormDialog,
    [List.name]: List,
  },
  directives: { clickOutside },
  props: {
    activityObj: Object,
  },
  data() {
    return {
      taskId: '', //会员 任务中心 任务id
      dataList: [],
      formCustom: {},
      activityPictureUrl: '',
      showMenu: false,
      questionList: [],
      groupNameList: [],
      ruleValidate: {},
      showModal: false,
      isDisabled: false,
      submitDocument: '提交',
      awardObj: {},
      showCoupon: false,
      couponList: [],
      previewFlag: false,
      isCutoff: false, // 是否已截止提交
      isContinue: false, // 是否再来一单
      loginType: '', // 活动登录类型
      activityUrl: '', // 当前活动地址
      isLoginFlag: false, // 默认没有登录
      activityTypeFlag: '', // 前端定义的小程序类型：1体验店（hi荣耀），2直营店
      miniprogramFlag: false, //判断是否在小程序环境内打开
      settingId: '', //奖项id
      giftActivityCode: '',
      isCorrectClient: true, // 是否在正确的客户端打开
      originLoginType: '', // 原始登录类型（转换前）
      activityStatus: '', //活动状态
      activityStartTime: '', //活动开始时间
      activityEndTime: '', //活动结束时间
      time: 0,
      showTime: '',
      timeIntervalState: '', //0：当天的未开始（倒计时展示） 1:当天的进行中 2:当天的已结束（时间区间展示）
      showHistory: false, //是否展示查看历史按钮
      isMemberId: false,
      positionInfo: {},
    };
  },
  computed: {
    couponReward() {
      let strArr = [];
      this.couponList.forEach((item) => {
        strArr.push(`${item.goodsName} * 1`);
      });
      return strArr.join(',');
    },
    submitButtonIsDisabled() {
      if (this.isDisabled) {
        return true;
      } else if (this.previewFlag) {
        return true;
      } else if (this.loginType !== LoginType.None && !this.isLoginFlag) {
        return true;
      } else if (this.activityStatus != ActivityStatus.running) {
        return true;
      } else if (this.activityStatus == ActivityStatus.running && [TimeIntervalState.notStarted, TimeIntervalState.finished].includes(this.timeIntervalState)) {
        return true;
      } else {
        return false;
      }
    },
    // 是否是会员
    isMemberInner() {
      // 对传入的字段，进行字符串和布尔值场景进行兼容
      return this.isMemberId === 'true' || this.isMemberId === true;
    },
    isNoLogin() {
      return this.loginType !== 'none' && (!this.isLoginFlag || !this.isMemberInner);
    },
  },
  created() {
    const eventTrackingData = JSON.parse(sessionStorage.getItem('eventTrackingData') || '{}');
    this.taskId = this.$route.query.taskId;
    if (this.$route.query.settingId) {
      this.settingId = this.$route.query.settingId;
    }
    if (this.$route.query.giftActivityCode) {
      this.giftActivityCode = this.$route.query.giftActivityCode;
    }
    console.log('settingId====', this.settingId, this.giftActivityCode);
    console.log('taskId', this.taskId);
    this.initData();
    if (this.$route.query.preview) {
      this.previewFlag = true;
    }
    if (this.taskId) {
      this.handleIntoCustomForm(); //埋码-会员任务中心
    }
    this.loginType = sessionStorage.getItem('loginType') || '';
    /**
     * 如果是无需登陆，自定义表单只有hi荣耀，方便无需登陆再去配置h5链接需要微信登陆时，去对应的小程序拉起登陆
     * 直营店只有有大转盘和专题活动类型，其它活动直营店没有
     */
    this.activityTypeFlag = sessionStorage.getItem('activityTypeFlag') || '1';
    const code = this.$route.query.activityCode || this.activityObj.activityCode;
    this.isLoginFlag = sessionStorage.getItem('isLoginFlag') === 'true' || sessionStorage.getItem('isLoginFlag') === true ? true : false;
    this.activityCode = code;
    this.isMemberId = sessionStorage.getItem('isMemberId');
    // 组装当前地址
    this.activityUrl = location.origin + '/hd/hdmain?activityCode=' + code;
    if (eventTrackingData && eventTrackingData.storeCode && eventTrackingData.guideUserId) {
      this.activityUrl =
        this.activityUrl + '&ay=' + eventTrackingData.activityType + '&GUID=' + eventTrackingData.guideUserId + '&SC=' + eventTrackingData.storeCode;
    }
    this.miniprogramFlag = window.__wxjs_environment === 'miniprogram';
    console.log('miniprogramFlag-自定义表单', this.miniprogramFlag);
  },
  mounted() {
    this.originLoginType = sessionStorage.getItem('originLoginType');
    this.isCorrectClient = checkClient(this.originLoginType);
  },
  methods: {
    //确认弹窗
    confirmModal() {
      let self = this;
      let extendConfig = this.$utils.getStorageItemObj('extendConfig');
      //提交成功后，完成任务，更新任务状态
      if (this.taskId) {
        this.updateTaskStatus();
      }
      if (extendConfig && (extendConfig.nextActivity || extendConfig.nextUrl)) {
        let nextActivity = extendConfig.nextActivity || extendConfig.nextUrl;
        if (nextActivity.indexOf('http') == -1 && nextActivity.indexOf('https') == -1 && nextActivity.indexOf('HD') > -1) {
          let path = '/hdmain?activityCode=' + nextActivity;
          self.$router.push({
            path: path,
          });
          self.$store.commit('base/setIsRouterAlive', false);
          self.$nextTick(() => self.$store.commit('base/setIsRouterAlive', true));
        } else {
          let currentOrigin = window.location.origin;
          if (nextActivity.indexOf(currentOrigin) > -1 && nextActivity.indexOf('hdmain') > -1) {
            let path = '/hdmain?' + nextActivity.split('?')[1];
            self.$router.push({
              path: path,
            });
            self.$store.commit('base/setIsRouterAlive', false);
            self.$nextTick(() => self.$store.commit('base/setIsRouterAlive', true));
          } else {
            window.location.href = nextActivity;
          }
        }
      } else {
        self.$router.push({
          name: 'submittedForm',
          query: { activityCode: self.activityObj.activityCode, taskId: self.taskId },
        });
      }
    },
    // 判断是否是有会员码
    isMember() {
      // 支付宝活动就不用判断了，因为支付宝没有会员
      let alipayUserId = sessionStorage.getItem('alipayUserId');
      if (alipayUserId) return;

      let self = this;
      // let userBase = self.$store.state.userInfo.userBase;
      let userBase = {};
      let userInfo = sessionStorage.getItem('userInfo');

      if (userInfo) {
        userInfo = JSON.parse(userInfo);
        userBase = Object.assign(userBase, userInfo);
      }
      let params = {
        memberInfoVO: {
          wechatOpenId: userBase.openId || '', //openid   oWtAW0fVA5Rwl8lYrHLnnsJqgufE
          identifier: userBase.unionid || '', //unionid  o93zEwzIjTJR1a_3X4_UEz7ct4Co
        },
      };
      self.$api.post({
        sc: 'member',
        url: 'memberInfoMiniManage/getMemberInfoModelVOByCheck',
        params: params,
        success: (r) => {
          if (r.result) {
            self.memberCode = r.result.accountNo;
          }
        },
      });
    },
    //加载表单问题数据
    async initData() {
      let self = this;
      const positioningFlag = sessionStorage.getItem('positioningFlag') === 'true' ? true : false;
      if (positioningFlag) {
        self.positionInfo = await getPosition();
      } 
      self.$api.post({
        sc: 'mobileMarketingH5',
        url: 'questionActivity/queryMiniActivityQuestionDetail/' + self.activityObj.activityCode,
        params: {
          longitude: self.positionInfo.longitude || '',
          dimension: self.positionInfo.latitude || '',
        },
        success: (r) => {
          let result = r.result || {};
          const showContentFlag = result.showContentFlag;
          self.formCustom = result;
          self.activityStatus = result.activityStatus;
          self.time = result.countdown;
          self.showTime = result.showTime;
          self.timeIntervalState = result.timeIntervalState;
          self.showHistory = result.showHistory;
          self.activityStartTime = result.activityStartTime || '';
          self.activityEndTime = result.activityEndTime || '';
          if (
            (result.activityStatus && result.activityStatus !== ActivityStatus.running) ||
            (result.activityStatus && result.activityStatus == ActivityStatus.running && ['0', '2'].includes(result.timeIntervalState))
          ) {
            self.$refs.activityStatusDialogRef.open();
          }
          if (result.activityPictureUrl) {
            if (result.activityPictureUrl.indexOf('{') > -1) {
              self.activityPictureUrl = self.$utils.getImageUrl(JSON.parse(result.activityPictureUrl).file);
            } else {
              self.activityPictureUrl = self.$utils.getImageUrl(result.activityPictureUrl);
            }
          }
          result.questionList.map((el) => {
            if (el.questionType === 'channel') {
              if (el.activityItemChannel) {
                el.channelName = el.activityItemChannel.channelName;
                el.activityChannelId = el.activityItemChannel.id;
                el.answerContent = el.activityItemChannel.channelCode + ':' + el.channelName + '-' + el.channelActivityCode;
              }
            }
          });
          self.questionList = result.questionList;
          if (result.customRewardSettingDtoList && result.customRewardSettingDtoList.length > 0) {
            self.couponList = result.customRewardSettingDtoList;
            self.showCoupon = true;
          }
          const extendConfig = this.$utils.getStorageItemObj('extendConfig');
          this.submitDocument = extendConfig.submitDocument ? extendConfig.submitDocument : '提交';
          let activityResult = sessionStorage.getItem('activityResult');
          if (activityResult) {
            activityResult = JSON.parse(activityResult);
            // 如果接口字段activityConfig?.displayQuantityFlag为1需要显示剩余份数，且剩余份数remnantNum有值，才显示剩余份数
            if(activityResult.activityConfig.displayQuantityFlag && activityResult.activityConfig.displayQuantityFlag === 1 && activityResult.remnantNum && activityResult.remnantNum*1 > 0){
              this.submitDocument = `${this.submitDocument}（剩${activityResult.remnantNum}份截止提交）`
            }
          }
          // showContentFlag 判断填写内容是否需要回显
          if (showContentFlag) {
            self.queryUserAnswer();
          }
        },
      });
    },
    //查询已提交数据
    queryUserAnswer() {
      let self = this;
      const loginType = sessionStorage.getItem('loginType');
      let params = {
        activityCode: self.activityObj.activityCode,
        loginType: loginType,
      };
      self.$api.post({
        sc: 'mobileMarketingH5',
        url: 'questionActivity/queryUserQuestionAnswer',
        params: params,
        success: (r) => {
          let questionList = self.questionList;
          let answerList = r.result || [];
          let typeArr = ['single_choice', 'multiple_choice'];
          if (answerList.length > 0) {
            for (let i in questionList) {
              for (let j in answerList) {
                if (answerList[j].questionType === 'evaluation') {
                  answerList[j].answerVO.answerContent = Number(answerList[j].answerVO.answerContent);
                }
                if (questionList[i].id == answerList[j].answerVO.questionId) {
                  if (typeArr.indexOf(questionList[i].questionType) > -1) {
                    let arr = answerList[j].answerVO.answerContent.split(',');
                    for (let k in arr) {
                      let arr2 = arr[k].split(':');
                      let optionList = questionList[i].optionList;
                      for (let m in optionList) {
                        if (optionList[m].optionCode == arr2[0]) {
                          optionList[m]._isSelect = true;
                        }
                      }
                    }
                  } else if (questionList[i].questionType == 'attachment') {
                    if (answerList[j].answerVO.answerContent) {
                      let urlArr = answerList[j].answerVO.answerContent.split(',');
                      questionList[i].desc = [];
                      urlArr.forEach((element) => {
                        questionList[i].desc.push(element);
                      });
                    }
                  } else {
                    questionList[i].answerContent = answerList[j].answerVO.answerContent;
                  }
                }
              }
            }
          }
        },
      });
    },
    addAttr(questionType) {
      let obj = {
        questionType: questionType,
        title: '',
        desc: '',
        mustFlag: '',
        optionList: [
          {
            optionCode: '',
            optionContent: '',
          },
        ],
      };
      this.questionList.push(obj);
    },
    //关闭
    handleClose() {
      let tabItemName = this.$parent.name;
      this.$emit('handleClose', tabItemName);
    },
    goDetail(data) {
      this.$router.push({
        name: 'submittedForm',
        query: { activityCode: data.activityCode, historyFormConnectionId: data.connectionId },
      });
    },
    timeDownFinished() {
      this.initData();
    },
    queryHistoryData() {
      this.$refs.selectHistoryFormDialog.openModel({ activityCode: this.activityObj.activityCode });
    },
    async submit() {
      if (this.submitDocument == '活动已截止提交') {
        Toast('活动已截止提交');
        return;
      }
      let self = this,
        fileQuestion = {}, // 附件
        checkMustFlag = false,
        phoneFlag = false,
        addressFlag = false,
        isFile = false,
        formCustom = self.formCustom,
        questionFalg = false,
        textLenFlag = false,
        multipleTextLenFlag = false,
        file = [], //questionFalg记录是否需要上传文件
        formTimeValue = false; //
      let userBase = self.$store.state.userInfo.userBase;
      let userInfo = sessionStorage.getItem('userInfo');
      if (userInfo) {
        userInfo = JSON.parse(userInfo);
        userBase = Object.assign(userBase, userInfo);
      }
      let userGender = '';
      if (userBase.sex == 1 || userBase.gender == 'm') {
        userGender = '1';
      } else if (userBase.sex == 2 || userBase.gender == 'f') {
        userGender = '2';
      }
      formCustom = Object.assign(formCustom, userBase);
      formCustom.userOpenid = userBase.openId || ''; //oWtAW0fVA5Rwl8lYrHLnnsJqgufE
      formCustom.userUnionid = userBase.unionid || ''; //o93zEwzIjTJR1a_3X4_UEz7ct4Co
      formCustom.userGender = userGender;
      formCustom.nickName = userBase.nickName;
      formCustom.alipayUserId = sessionStorage.getItem('alipayUserId') || '';

      if (this.showCoupon) {
        formCustom.customRewardRecodeDto = {
          userUnionid: userBase.unionid || '', //o93zEwzIjTJR1a_3X4_UEz7ct4Co
          userOpenid: userBase.openId || '', //oWtAW0fVA5Rwl8lYrHLnnsJqgufE
          nickName: userBase.nickName || '', //Buddy
          memberCode: this.memberCode,
          alipayUserId: sessionStorage.getItem('alipayUserId') || '',
        };
      }
      formCustom.questionList.filter((item) => {
        if (item.answerContent && item.answerContent.length > 100) {
          if (item.questionType == 'multiple_text') {
            multipleTextLenFlag = true;
          } else if (item.questionType == 'single_text') {
            textLenFlag = true;
          } else if (item.questionType == 'form_time') {
            formTimeValue = true;
          }
        }
        let text = '',
          textArr = [];
        if (item.optionList) {
          item.optionList.filter((items) => {
            if (item.questionType == 'multiple_choice' || item.questionType == 'single_choice') {
              if (items._isSelect) {
                text = items.optionCode + ':' + items.optionContent;
                textArr.push(text);
              }
              item.answerContent = textArr.join(',');
            }
          });
        }
        //校验必填数据
        if (item.mustFlag == '1') {
          //如果答案没值则校验不通过，如果未上传附件也校验不过
          if (
            (item.answerContent && item.answerContent.toString().trim()) ||
            (item.questionType == 'attachment' && item.answerContent) ||
            item.answerContent === 0 ||
            (item.questionType == 'channel' && item.activityItemChannel)
          ) {
            self.$set(item, 'isCheckError', false);
          } else {
            self.$set(item, 'isCheckError', true);
            if (item.phoneNumberVerification && item.phoneNumberVerification !== '0') {
              this.$set(item, 'errorMsg', '请输入你的手机号');
            }
            checkMustFlag = true;
          }

          // 校验上传附件
          if (item.questionType == 'attachment') {
            if (item.answerContent.length) {
              this.$set(item, 'isCheckError', false);
              isFile = false;
            } else {
              self.$set(item, 'isCheckError', true);
              isFile = true;
            }
          }

          // 校验地址
          if (item.questionType == 'address_text') {
            let answer = JSON.parse(item.answerContent);
            if (!answer.province || !answer.city || !answer.zone) {
              this.$set(item, 'isCheckError', true);
              this.$set(item, 'errorMsg', '请选择地区');
              addressFlag = true;
            } else if (!answer.detail) {
              this.$set(item, 'isCheckError', true);
              this.$set(item, 'errorMsg', '请输入详细地址');
              addressFlag = true;
            } else if (answer.detail && answer.detail.length < 5) {
              this.$set(item, 'isCheckError', true);
              this.$set(item, 'errorMsg', '详细地址不能小于五个字符');
              addressFlag = true;
            }
          }
        }
        if (item.phoneNumberVerification && item.phoneNumberVerification != '0') {
          if (item.answerContent && item.answerContent.trim()) {
            if (!/^1[0-9]{10}$/.test(item.answerContent)) {
              this.$set(item, 'isCheckError', true);
              this.$set(item, 'errorMsg', '请输入正确的手机号');
              phoneFlag = true;
            } else {
              this.$set(item, 'isCheckError', false);
            }
          } else if (item.mustFlag == '0') {
            this.$set(item, 'isCheckError', false);
          }
        }
        if (item.phoneNumberVerification == '2' && item.answerContent && !phoneFlag) {
          if (item.verificationCode && item.verificationCode.trim()) {
            this.$set(item, 'isCheckError', false);
          } else {
            this.$set(item, 'isCheckError', true);
            this.$set(item, 'errorMsg', '请输入验证码');
            phoneFlag = true;
          }
        }
        if (item.questionType == 'attachment' && Array.isArray(item.answerContent)) {
          item.desc = '';
          if (item.answerContent.length > 0) {
            let answerAttachment = item.answerContent;
            let attachmentType = item.attachmentType == '0' ? '图片' : '视频';
            let answerString = '';
            answerAttachment.forEach((element) => {
              if (element.path && element.status == 'done') {
                this.$set(item, 'isCheckError', false);
                if (!answerString) {
                  answerString = element.path;
                } else {
                  answerString = answerString + ',' + element.path;
                }
                item.answerContent = answerString;
              } else if (element.status == 'uploading') {
                this.$set(item, 'isCheckError', true);
                Toast('请等待当前文件上传完毕');
                isFile = true;
              } else if (element.status == 'failed') {
                this.$set(item, 'isCheckError', true);
                Toast(`${attachmentType}上传失败，重新上传后方可提交表单`);
                isFile = true;
              }
            });
          } else {
            item.answerContent = '';
          }
        }
      });
      //校验不过，弹出提示
      if (checkMustFlag || phoneFlag || addressFlag || isFile) {
        // self.$utils.tips.checkRequired();
        return false;
      } else {
        formCustom.questionList.forEach((item) => {
          if (item.phoneNumberVerification == '2') {
            formCustom.verificationCode = item.verificationCode;
            formCustom.redisKey = item.redisKey;
          }
        });
      }
      if (self.isDisabled) {
        return false;
      }
      self.isDisabled = true;
      self.saveoption(formCustom);
    },
    //上传图片至服务器
    uploadImgInfo(item) {
      let self = this;
      let pro = new Promise((resolve, reject) => {
        //需要上传到服务器的在这里可以进行ajax请求
        self.$api.post({
          sc: 'mobileMarketingH5',
          params: { file: item.fileData, fileName: item.fileName },
          notFilterNull: true,
          url: 'questionActivity/baseUpload',
          success: (r) => {
            let result = r.result || '{}';
            result = JSON.parse(result);
            resolve(result);
          },
          failure: () => {
            self.isDisabled = false;
          },
        });
      });
      return pro;
    },
    saveoption(params) {
      params.questionList.forEach((item) => {
        item.optionList &&
          item.optionList.forEach((el) => {
            this.$set(el, 'selectFlag', el._isSelect);
          });
        item.answerContent = item.answerContent || '';
        item.mustFlag = item.mustFlag === '0' && item.answerContent === '' ? '' : item.mustFlag;
      });
      let extendConfig = this.$utils.getStorageItemObj('extendConfig');
      // 奖项id
      params.settingId = this.settingId;
      // 奖品活动编码
      params.giftActivityCode = this.giftActivityCode;
      params.times = extendConfig.times;
      params.activityCode = this.activityObj.activityCode;
      params.associationActivityCode = sessionStorage.getItem('associationActivityCode');
      let crtlParams = sessionStorage.getItem('crtlParams');
      if (crtlParams) {
        crtlParams = JSON.parse(crtlParams);
        params.loginType = crtlParams.loginType;
        params.times = 'once';
      }
      if (sessionStorage.getItem('connectionId')) {
        params.connectionId = sessionStorage.getItem('connectionId');
      }
      if (!sessionStorage.getItem('alipayUserId')) {
        // 支付宝已经是隐私结构体了
        let privacyKeys = {
          nickName: '$PrivacyPlain$',
        };
        //隐私信息保存
        let privacyKeyLsit = [
          {
            nickName: 'nickName',
            typeText: 'NICK_NAME',
            labelText: 'mktStudentRewardRecodeNickName',
          },
        ];
        this.$utils.privacySave(privacyKeys, privacyKeyLsit, params);
      }
      let self = this;
      self.$api.post({
        sc: 'mobileMarketingH5',
        params: params,
        notFilterNull: true,
        url: 'questionActivity/editQuestionAnswer',
        success: (r) => {
          if (r.code == 200) {
            if (r.result) {
              if (r.result.connectionId) sessionStorage.setItem('connectionId', r.result.connectionId);
            }
            let result = r.result || {};
            if (result.insertFlag) {
              self.isCutoff = true;
              self.submitDocument = '活动已截止提交';
              self.isDisabled = true;
              return;
            }
            if (self.showCoupon && result.customRewardSettingDtoList && result.customRewardSettingDtoList.length > 0) {
              self.awardObj.finalCouponList = result.customRewardSettingDtoList;
              self.$refs.formCouponModal.openModel();
              return false;
            }
            self.$utils.tips.oSuccess();

            let activityResult = JSON.parse(sessionStorage.getItem('activityResult'));
            if (activityResult && activityResult.isUsed && activityResult.isUsed == '0' && activityResult.continueFlag && activityResult.continueFlag == '1') {
              this.isContinue = true;
            } else {
              //来自自定义表单
              sessionStorage.setItem('isFromCustomForm', '1');
              this.saveoptionAfter();
            }
          } else {
            let content = '活动过于火爆，请稍后再试';
            if (r && r.message) {
              content = r.message;
            }
            self.isDisabled = false;
            Toast(content);
          }
        },
        failure: (err) => {
          self.isDisabled = false;
          Toast('活动过于火爆，请稍后再试');
        },
      });
    },
    /**
     * 提交后的处理
     */
    saveoptionAfter() {
      const self = this;
      // 自定义表单的extendConfig，取得是在hdmain里面的接口getByActivityIdForH5，返回的activityConfig
      const extendConfig = this.$utils.getStorageItemObj('extendConfig');
      // 父级页面信息
      const parentPageParams = {
        activityCode: '',
        parentPage: 'customForm_commonForm',
        parentActivityCode: this.activityCode,
      };
      //提交成功后，完成任务，更新任务状态
      if (this.taskId) {
        this.updateTaskStatus();
      }
      if (extendConfig && (extendConfig.nextActivity || extendConfig.nextUrl)) {
        const nextActivity = extendConfig.nextActivity || extendConfig.nextUrl;
        // 下级组件跳转，nextActivity为活动编码
        if (nextActivity.indexOf('http') == -1 && nextActivity.indexOf('https') == -1 && nextActivity.indexOf('HD') > -1) {
          parentPageParams.activityCode = nextActivity;
          const path = comUtils.appendParamsToURL(parentPageParams);
          self.$router.push({
            path: path,
          });
          self.$store.commit('base/setIsRouterAlive', false);
          self.$nextTick(() => self.$store.commit('base/setIsRouterAlive', true));
        } else {
          const currentOrigin = window.location.origin;
          // 链接跳转
          if (nextActivity.indexOf(currentOrigin) > -1 && nextActivity.indexOf('hdmain') > -1) {
            parentPageParams.activityCode = nextActivity.split('activityCode=')[1] || '';
            const path = comUtils.appendParamsToURL(parentPageParams);
            self.$router.push({
              path: path,
            });
            self.$store.commit('base/setIsRouterAlive', false);
            self.$nextTick(() => self.$store.commit('base/setIsRouterAlive', true));
          } else {
            window.location.href = nextActivity;
          }
        }
      } else if (this.settingId) {
        sessionStorage.setItem('setting', 'true');
        const path = `/hdmain?activityCode=${this.giftActivityCode}&settingId=${this.settingId}`;
        this.$router.push({
          path: path,
        });
      } else {
        self.$router.push({
          name: 'submittedForm',
          query: { activityCode: self.activityObj.activityCode, taskId: self.taskId },
        });
      }
    },
    //任务中心 任务完成
    updateTaskStatus() {
      let userInfo = sessionStorage.getItem('userInfo');
      userInfo = JSON.parse(userInfo);
      let loginType = sessionStorage.getItem('loginType');
      Toast.loading({
        message: '加载中...',
        forbidClick: true,
        duration: 0,
      });
      this.$api.post({
        sc: 'member2',
        url: `memberInfoMiniManage/updTaskDone`,
        params: {
          id: this.taskId,
          uniqId: loginType == 'wechat' ? userInfo.unionid || '' : userInfo.userId || '',
          idType: loginType == 'wechat' ? '1' : '6',
        },
        success: (r) => {
          Toast.clear();
          if (r.code == 500) {
            //	Dialog({ message: "系统繁忙，请稍后重试。" });
          }
          if (r.code == 200) {
            Dialog({ message: '任务完成！' });
          }
        },
        failure: (err) => {
          Toast.clear();
          Dialog({ message: '活动过于火爆，请稍后再试' });
        },
      });
    },
    modelOk() {},
    modelCancel() {
      this.$router.push({
        name: 'submittedForm',
        params: { activityCode: this.activityObj.activityCode },
      });
    },
    myConfirm(content, title) {
      let self = this;
      return new Promise(function (resolve, reject) {
        Dialog.alert({
          title: title || '提示',
          message: `<p>${content}</p>`,
        })
          .then(() => {
            resolve('ok');
          })
          .catch(() => {
            resolve(false);
          });
      });
    },
    /**
     * 再来一单返回方法
     */
    handleBacks() {
      this.saveoptionAfter();
    },
    /**
     * 再来一单方法
     */
    handleContinue() {
      sessionStorage.removeItem('connectionId');
      this.$router.go(0);
    },
    //埋码-会员任务中心
    handleIntoCustomForm() {
      let loginType = sessionStorage.getItem('loginType');
      const params = {
        actionCode: '800000007',
        actionName: '问券调查',
        content: {
          channel: loginType == 'undefined' ? '' : loginType == 'wechat' ? '微信' : '支付宝',
          load: 1, //针对加载事件增加{“load”: “1”}
          eventType: 1,
          taskId: this.taskId,
          activityCode: this.activityObj.activityCode,
          url: location.origin + '/hd/hdmain?activityCode=' + this.activityCode + '&taskId=' + this.taskId,
        },
      };
      const eventTrackingData = JSON.parse(sessionStorage.getItem('eventTrackingData') || '{}');
      if (eventTrackingData && eventTrackingData.storeCode && eventTrackingData.guideUserId) {
        params.content.activityName = eventTrackingData.activityName;
        params.content.activityType = eventTrackingData.activityType;
        params.content.guideUserId = eventTrackingData.guideUserId;
        params.content.channelCode = eventTrackingData.storeCode;
      }
      comUtils.handleBatchReport(this, params);
    },
  },
};
</script>

<style lang="scss" scoped>
.cutoffDialog {
  width: 100%;
  height: 400px;
  background: transparent;
  display: flex;
  justify-content: center;
  align-items: center;
  /deep/ .van-dialog__content {
    width: 80%;
    min-width: 225px;
    height: 300px;
    .cutoff {
      width: 100%;
      height: 100%;
      background-color: #ffffff;
      border-radius: 10px;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      img {
        width: 150px;
        height: 100px;
        margin-top: 30px;
      }
      .cutoffText {
        padding: 30px 0;
        font-size: 16px;
      }
      .cutoffButton {
        width: 160px;
        height: 35px;
        font-size: 16px;
        border-radius: 55px;
        color: #ffffff;
        background-image: linear-gradient(90deg, #3eacf5 2%, #4ddced 100%);
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }
  }
}

.continue {
  width: 100%;
  height: auto;
  background: transparent;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: initial;
  /deep/ .van-dialog__content {
    width: auto;
    height: auto;
    overflow: initial;
    background: transparent;
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 20px;
    img {
      width: 320px;
      height: 310px;
      border-radius: 20px;
    }
    .continueButton1,
    .continueButton2 {
      width: 110px;
      height: 30px;
      position: absolute;
      bottom: 37px;
    }
    .continueButton1 {
      left: 40px;
    }
    .continueButton2 {
      right: 40px;
    }
  }
}
.couponTips {
  font-size: 12px;
  color: red;
  line-height: 2;
  margin: auto;
}
.is-item-required:before {
  content: '*';
  display: inline-block;
  margin-right: 4px;
  margin-top: -1px;
  line-height: 1;
  font-family: SimSun;
  font-size: 16px;
  color: #ed3f14;
  float: left;
}
.is-check-error {
  border: 1px dashed #ff3d17;
  width: 100%;
  padding: 0 10px;
  box-sizing: border-box;
}
.radio-content {
  page-break-before: always;
  display: -ms-flexbox;
  display: -webkit-box;
  display: flex;
  -ms-flex-align: center;
  -webkit-box-align: center;
  -ms-flex-pack: center;
  -webkit-box-pack: center;
  justify-content: center;
  flex-direction: column;
  margin-bottom: 8px;
}
.radio-title {
  width: 100%;
  color: #333;
  padding: 10px 25px 8px 25px;
  font-size: 12px !important;
  font-weight: bold;
}
.noLogin {
  position: relative;
}
.noLogin::before {
  content: '';
  position: fixed; /* 遮罩层覆盖整个屏幕 */
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.5); /* 半透明黑色遮罩 */
  z-index: 888; /* 确保遮罩层在最上层 */
}
.runtime-custom-form .dynamic-attr-content {
  font-size: 24px;
  width: 100%;
  background-color: whitesmoke;
  display: flex;
  flex-direction: column;
  align-items: center;
  box-sizing: border-box;
}
.runtime-custom-form .dynamic-attr-content .custom-form-top-img {
  margin-bottom: 10px;
  height: 56vw;
}
.runtime-custom-form .dynamic-attr-content .question-content {
  width: calc(100vw - 30px);
  display: flex;
  justify-content: center;
  .dynamic-property-form {
    width: 100%;
    background-color: #ffffff;
    padding: 10px 15px;
    border-radius: 5px;
    margin-bottom: 10px;
  }
}
.runtime-custom-form .dynamic-attr-content .radio-options {
  display: inline-block;
  display: flex;
  flex-direction: column;
  justify-content: center;
  color: #333333;
  height: 20px !important;
}
.runtime-custom-form .dynamic-attr-content .radio-options:last-child {
  border-bottom: 0;
}
.runtime-custom-form .dynamic-attr-content .radio-options:last-child:after {
  height: 0;
}
.radio-options-content {
}
.radio-options-label {
  display: inline-block;
  font-size: 14px;
  color: #333;
}
.radio-options-value {
  float: right;
}
.radio-options-value .selected .ivu-icon {
  color: #00b1ff;
}
.radio-options-value .selected {
  color: #00b1ff;
  font-size: 16px;
}
.dynamic-attr-text {
  width: 100%;
  page-break-before: always;
  display: -ms-flexbox;
  display: -webkit-box;
  display: flex;
  -ms-flex-align: center;
  -webkit-box-align: center;
  -ms-flex-pack: center;
  -webkit-box-pack: center;
  justify-content: center;
  flex-direction: column;
  margin-bottom: 8px;
}
.dynamic-attr-text-title {
  width: 100%;
  color: #333;
  font-weight: bold;
  font-size: 12px !important;
  display: block;
  // align-items: center;
  margin-bottom: 5px;
}
.text-item-value {
  width: 100%;
  margin-bottom: 15px;
}
.text-item-value .ivu-input {
  font-size: 14px;
}
.text-item-input .ivu-input {
  height: 32px;
}
.runtime-custom-form .ihr {
  margin: 0px 0px;
}
.runtime-custom-form .btn-submit {
  background: #256fff;
  border-radius: 55px;
  height: 78px;
  font-size: 28px;
  color: #ffffff;
}
.runtime-custom-form .disabled {
  background: #b8cdf9 !important;
  color: #ffffff !important;
  border: 1px solid #b8cdf9;
}
.dynamic-attr-file .ivu-upload-select button {
  background: #00b1ff;
  border-radius: 4px;
  color: #ffffff;
  height: 30px;
  font-size: 12px;
  width: 64px;
  padding: 0;
}
.ivu-btn > .ivu-icon {
  font-size: 16px;
}
.radio-options-value .ivu-icon {
  font-size: 16px !important;
}
.ihlp-icon,
.ihlp-icon-r {
  color: #b2b2b2;
}
input,
textarea {
  -webkit-appearance: none;
}
.ivu-input-wrapper {
  display: block !important;
  line-height: 1 !important;
}
.ivu-btn {
  border: 0 !important;
}
.btn {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 70px;
  background-color: #ffffff;
}
@media (min-width: 750px) {
  .fixedPage {
    left: calc(50% - 375px);
  }
}
.activity-status {
  width: 200px;
  height: 300px;
}
.history {
  position: fixed;
  top: 25px;
  right: 0;
  border: 1px solid rgba(255, 255, 255, 1);
  border-right: transparent;
  border-radius: 50px 0 0 50px;
  font-size: 12px;
  color: #ffffff;
  width: 68px;
  height: 27px;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>



// WEBPACK FOOTER //
// src/page/vibrantRubikCube/runtime/customForm.vue